// Legacy naive calendar values are California wall times, not UTC.
const californiaFormatter = new Intl.DateTimeFormat('en-US', {timeZone:'America/Los_Angeles', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', hourCycle:'h23'});
export function californiaInput(value) {
  if (!value) return '';
  if (!/(Z|[+-]\d\d:\d\d)$/.test(value)) return value.slice(0, 16);
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const parts = californiaFormatter.formatToParts(date);
  const p = Object.fromEntries(parts.map(x => [x.type,x.value]));
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
}
export function californiaLabel(value) {
  const local = californiaInput(value);
  if (!local) return '—';
  const [date,time] = local.split('T');
  const [y,m,d] = date.split('-');
  return `${m}/${d}/${y} ${time || ''} · California (Los Ángeles)`;
}
